import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Proceeding } from '@/module/Author/Proceeding';
import { ProceedingValidationAction } from '@/module/Author/Proceeding/Validation/ProceedingValidationAction';
import { ProceedingCard } from '@/module/Author/Proceeding/components/Card/ProceedingCard';

interface CollapsableProceedingProps {
  title: string;
  proceedings: Proceeding[];
}

export function CollapsableProceeding({ title, proceedings }: CollapsableProceedingProps) {
  return (
    <CollapsableGroup
      title={title}
      items={proceedings}
      renderValidation={p => (
        <ProceedingValidationAction
          proceedingId={p.id}
          variant="compact"
        />
      )}
      renderItem={proceeding => <ProceedingCard proceeding={proceeding} />}
    />
  );
}
